<template>
	<div class="bg-F3F3F3">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="row stc-container body-height">
			<div class="col-md-8 p-4">
				<div class="tc-left-head cl-w flex justify-content-between">
					<div>
						<div class="">
							{{changeNum(convertToTimeZone(orderInfo.start_time).date.week)}}，
							{{convertToTimeZone(orderInfo.start_time).date.year}}{{ $t('teacherConfirms.year') }}
							{{convertToTimeZone(orderInfo.start_time).date.month}}{{ $t('teacherConfirms.month') }}
							{{convertToTimeZone(orderInfo.start_time).date.day}}{{ $t('teacherConfirms.day') }}（{{ timeZone}}）
						</div>
						<div class="ftr-1-5 mt-3">
							{{convertToTimeZone(orderInfo.start_time).date.hour}}:{{convertToTimeZone(orderInfo.start_time).date.minute}} /
							{{convertToTimeZone(orderInfo.finish_time).date.hour}}:{{convertToTimeZone(orderInfo.finish_time).date.minute}}
						</div>
					</div>
					<div class="br4 bg-w py-2 px-4 cl-theme" style="height: 40px;">
						{{ $t('teacherConfirms.classId') }}{{formatNumber(orderInfo.id) }}
					</div>
				</div>
				<div class="bg-w pd16">
					<div class=" flex alcenter">
						<img :src="orderInfo.photo_image" alt="" class="photo-40" />
						<span class="ftr-1-25 ftw600 ml10">{{orderInfo.name}} {{orderInfo.surname}}</span>
					</div>
					<!-- <div class="mt-3">
						{{orderInfo.course_name}}
					</div> -->
					<div class="mt-4 flex">
						<div>
							<div class="ft14 cl-info">
								{{ $t('forClassIndex.class') }}
							</div>
							<div class="mt-2">
								{{orderInfo.course_name}}
							</div>
						</div>
						<div class="ms-5">
							<div class="ft14 cl-info">
								{{ $t('cashDesk.subject') }}
							</div>
							<div class="mt-2">
								{{orderInfo.course_classify_name}}
							</div>
						</div>
						<div class="ms-5">
							<div class="ft14 cl-info">
								{{ $t('teacherConfirms.duration') }}
							</div>
							<div class="mt-2">
								50 min
							</div>
						</div>
						
					</div>
					<div class="mt-4 cl-info ft14">
						{{ $t('teacherConfirms.languageCategory') }}
					</div>
					<div class="mt-2">
						{{orderInfo.teacher_language}}
					</div>
					<div class="mt-3 cl-info flex alcenter">
						<a-icon type="sound"></a-icon>
						<span class="ml10">{{ $t('teacherConfirms.restTimeNote') }}</span>
					</div>

					<div v-if="orderInfo.confirmation_status==1">
						<hr class="mt-4" />
						<div class="ftr-1-25 ftw600">
							{{ $t('teacherConfirms.contactTool') }}
						</div>
						<div class="flex alcenter mt-3">
							<img src="../../assets/image/commom/zoom.png" v-if="orderInfo.contact_way_text=='Zoom'" alt="" class="photo-40 br4" />
							<img src="../../assets/image/commom/voov.png" v-else alt="" class="photo-40 br4" />
							<div class="ml16"> {{orderInfo.contact_way_text}}</div>
							<div class="ms-5 text-center">
								<div class="cl-info ft12">
									{{ $t('teacherConfirms.avatar') }}
								</div>
								<div class="">
									{{orderInfo.contact_way_text=='Zoom'?orderInfo.contact_zoom_pmi:orderInfo.contact_voov_pmi}}
								</div>
							</div>
							<div class="ms-5 text-center">
								<div class="cl-info ft12">
									{{ $t('teacherConfirms.password') }}
								</div>
								<div class="">
									{{orderInfo.contact_way_text=='Zoom'?orderInfo.contact_zoom_password:orderInfo.contact_voov_password}}
								</div>
							</div>
						</div>
						<div class="mt-4" v-if="orderInfo.teacher_entry_time">
							<span class="cl-info">{{ $t('teacherConfirms.teacherEntryTime') }}</span>
							{{convertToTimeZone(orderInfo.teacher_entry_time).formattedTime }}
						</div>
						<div class="mt-3" v-if="orderInfo.user_entry_time">
							<span class="cl-info">{{ $t('teacherConfirms.studentEntryTime') }}</span>
							{{convertToTimeZone(orderInfo.user_entry_time).formattedTime }}
						</div>
						<hr />
						<div v-if="orderInfo.reservation_order_appendix.status1.length!=0">
							<div class="ftr-1-25 ftw600">
								{{ $t('teacherConfirms.notes') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400">
								<img src="../../assets/image/staduents/notes.png" alt=""
									style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;">
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status1">
										<div class="flex justify-content-between alcenter">
											<a :href="item.file" class="cl-theme ftw600 text-line-none"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="">
											{{convertToTimeZone(item.createtime).formattedTime}}
										</div>
									</div>

								</div>
							</div>
							<hr />
						</div>
						<div>
							<div class="ftr-1-25 ftw600">
								{{ $t('teacherConfirms.homework') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400">
								<img src="../../assets/image/staduents/notes.png" alt=""
									style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;">
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status2">
										<div class="flex justify-content-between alcenter">
											<a :href="item.file" class="cl-theme ftw600 text-line-none over-hide"
												style="width: 240px;"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="flex justify-content-between ">
											<div class="">
												{{convertToTimeZone(item.createtime).formattedTime}},{{item.upload_status=='1'?$t('common.studentsUpload'):$t('common.teacherUpload')}}
											</div>
											<div class="cl-theme clickAct" @click="deleteAppendix(item.id)">
												{{$t('common.delete')}}
											</div>
										</div>
										<div class="mt-2">
											{{item.remark}}
										</div>
									</div>

									<hr v-if="orderInfo.reservation_order_appendix.status2.length!=0" />
									<!-- <uploadFileVue @input="handleUplode">
										<div class="cl-theme ftr-1" :class="orderInfo.reservation_order_appendix.status2.length==0?'mt10':''">
											{{ $t('teacherConfirms.uploadHomework') }}
										</div>
									</uploadFileVue> -->
									<div class="cl-theme clickAct ftr-1" :class="orderInfo.reservation_order_appendix.status2.length==0?'mt10':''"
									@click="appendix_status = 2;openRemark=true">
										{{ $t('teacherConfirms.uploadHomework') }}
									</div>
								</div>
							</div>
							<hr />
						</div>
						<div class="">
							<div class="ftr-1-25 ftw600">
								{{ $t('teacherConfirms.test') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400">
								<img src="../../assets/image/staduents/notes.png" alt=""
									style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;">
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status3">
										<div class="flex justify-content-between alcenter">
											<a :href="item.file" class="cl-theme ftw600 text-line-none over-hide"
												style="width: 240px;"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="flex justify-content-between">
											<div class="">
												{{convertToTimeZone(item.createtime).formattedTime}},{{item.upload_status=='1'?$t('common.studentsUpload'):$t('common.teacherUpload')}}
											</div>
											<div class="cl-theme clickAct" @click="deleteAppendix(item.id)">
												{{$t('common.delete')}}
											</div>
										</div>
										<div class="mt-2">
											{{item.remark}}
										</div>
									</div>

									<hr v-if="orderInfo.reservation_order_appendix.status3.length!=0" />
									<!-- <uploadFileVue @input="handleUplodeTest">
										<div class="cl-theme ftr-1 " :class="orderInfo.reservation_order_appendix.status3.length==0?'mt10':''">
											{{ $t('teacherConfirms.uploadTest') }}
										</div>
									</uploadFileVue> -->
									<div class="cl-theme clickAct ftr-1 " :class="orderInfo.reservation_order_appendix.status3.length==0?'mt10':''"
									@click="appendix_status = 3;openRemark = true" >
										{{ $t('teacherConfirms.uploadTest') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="col-md py-4 pe-4">
				<div class="bg-w p-4 ">
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==2&&orderInfo.order_type==1">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.pendingTeacherConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.yourClassPending') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.cancelReschedulePolicy') }}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('teacherConfirms.policy') }} </a>
						</div>
					</div>
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==2&&orderInfo.order_type==2">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.pendingConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.classPendingConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.cancelReschedulePolicy') }}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('teacherConfirms.policy') }} </a>
						</div>
					</div>
					<div
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)!==1&& orderInfo.exception_status==1">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.pendingClass') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.classStartOnTime') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.cancelReschedulePolicy') }}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('teacherConfirms.policy') }} </a>
						</div>
					</div>
					<div
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)===1&&orderInfo.exception_status==1">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.classCompletedPendingConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.confirmWithin3Days', { time: convertToTimeZone(getFinDate(orderInfo.finish_time)).formattedTime ,timeZone:timeZone}) }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.reportClassNotCompleted') }}
						</div>
					</div>
					<div v-if="orderInfo.status==3">
						<div class="text-center ftr-1-25" >
							<!-- 课程已取消 -->
							{{$t('common.courseCancelled')}}
						</div>
					</div>
					<div v-if="orderInfo.status==2&&orderInfo.exception_status!=2">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.completed') }}
						</div>
						<div class="mt-3 cl-info" v-if="orderInfo.teacher_comment.length==0">
							{{ $t('teacherConfirms.rateTeacherWithin3Days') }}
						</div>
						<div class="mt-3 cl-info" v-else>
							{{ $t('teacherConfirms.classCompletedCongrats') }}
						</div>
					</div>
					<!-- 课程未完成 -->
					<div v-if="orderInfo.exception_status==2&&orderInfo.platform_status==1">
						<div v-if="!orderInfo.reservation_order_exception.result || orderInfo.reservation_order_exception.result==0">
							<div class="text-center ftr-1-25">
								{{ $t('teacherConfirms.classNotAccomplished') }}
							</div>
							<div class="mt-3 cl-info">
								{{ $t('teacherConfirms.waitingTeacherProcess', { time:convertToTimeZone(getFinDate(orderInfo.finish_time)).formattedTime,timeZone:timeZone  }) }}
							</div>
						</div>
						<div
							v-if="orderInfo.reservation_order_exception.result&&orderInfo.reservation_order_exception.status!=3&&orderInfo.reservation_order_exception.result!=0">
							<div class="text-center ftr-1-25">
								{{ $t('teacherConfirms.classNotCompletedResultConfirm') }}
							</div>
							<div class="mt-3 cl-info">
								{{ $t('teacherConfirms.processWithin48Hours', { time:convertToTimeZone(orderInfo.finish_time).formattedTime,timeZone:timeZone }) }}
							</div>
							<div class="mt-4">
								<span class="cl-info">{{ $t('teacherConfirms.teacherSolution') }}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='1'">{{$t('statusConfirms.result1')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='2'">{{$t('statusConfirms.result2')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='3'">{{$t('statusConfirms.result3')}}</span>
							</div>
							<div class="mt-2" v-if="orderInfo.reservation_order_exception.result==3">
								<span class="cl-info">{{ $t('teacherConfirms.refundAmount') }}</span>{{getCurrency()}}
								{{convertCurrency(orderInfo.reservation_order_exception.money)}}
							</div>
							
							<button type="button" class="btn btn-theme mt-3 wid-100"
								v-if="orderInfo.exception_status==2&&orderInfo.platform_status==1"
								@click="consentException()"> {{ $t('teacherConfirms.agree') }}</button>
							<button type="button" class="btn btn-light mt-3 wid-100"
								v-if="orderInfo.exception_status==2&&orderInfo.platform_status==1"
								@click="platformRuling()"> {{ $t('teacherConfirms.applyPlatformRuling') }}</button>
						</div>
						<div v-if="orderInfo.reservation_order_exception.status==3">
							<div class="text-center ftr-1-25">
								{{ $t('teacherConfirms.classNotCompleted') }}
							</div>
							<div class="mt-4">
								<span class="cl-info">{{ $t('teacherConfirms.teacherSolution') }}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='1'">{{$t('statusConfirms.result1')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='2'">{{$t('statusConfirms.result2')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='3'">{{$t('statusConfirms.result3')}}</span>
							</div>
							<div class="mt-2" v-if="orderInfo.reservation_order_exception.result==3">
								<span class="cl-info">{{ $t('teacherConfirms.refundAmount') }}</span>{{getCurrency()}}
								{{convertCurrency(orderInfo.reservation_order_exception.money)}}
							</div>
						</div>
					</div>
					<!-- 等待平台裁决 -->
					<div v-if="orderInfo.platform_status==2&&orderInfo.exception_status==2">
						<div class="text-center ftr-1-25">
							{{ $t('teacherConfirms.waitingPlatformRuling') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('teacherConfirms.pleaseWaitPlatform') }}
						</div>
					</div>
					<!-- 确认老师发起的课程 -->
					<button type="button" class="btn btn-theme mt-3 wid-100" @click="confirmationOrder()"
						v-if="orderInfo.status==1&&orderInfo.order_type==2&&timeCompare(orderInfo.start_time)===2&&orderInfo.confirmation_status==2">
						{{ $t('teacherConfirms.confirmClass') }}
					</button>
					<!-- 订单未确认 -->
					<button type="button" class="btn btn-light mt-3 wid-100" @click="cancelOrder()"
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==2">
						{{ $t('teacherConfirms.cancelClass') }}
					</button>

					<div
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)!==1&& orderInfo.exception_status==1">
						<button type="button" class="btn btn-theme mt-3 wid-100" v-if="showEnterClassRoom(orderInfo.start_time,orderInfo.finish_time)"
							@click="enterClassroom">{{ $t('teacherConfirms.enterClassroom') }}</button>
						<div class="mt-2 cl-theme text-center" v-if="showEnterClassRoom(orderInfo.start_time,orderInfo.finish_time)">
							{{ $t('teacherConfirms.interruptNote') }}
						</div>
						<button type="button" class="btn btn-light mt-3 wid-100" @click="isCourseCompleted = true" v-if="timeCompare24(orderInfo.start_time)">
							{{ $t('teacherConfirms.cancelClass') }}
						</button>
						<button type="button" class="btn btn-light mt-3 wid-100" @click="cancelOrder()" v-else>
							{{ $t('teacherConfirms.cancelClass') }}
						</button>
					</div>

					<div
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&orderInfo.exception_status==1&&timeCompare(orderInfo.finish_time)===1">
						<!-- 完成课程 -->
						<button type="button" class="btn btn-theme mt-3 wid-100"
							@click="accomplishOrder()">{{ $t('teacherConfirms.accomplishClass') }}</button>
						<button type="button" class="btn btn-light mt-3 wid-100" @click="isCourseCompleted = true">
							{{ $t('teacherConfirms.classNotAccomplished') }}
						</button>
					</div>
					<button type="button" class="btn btn-theme mt-3 wid-100"
						v-if="orderInfo.status==2&& orderInfo.teacher_comment.length==0&&orderInfo.exception_status!=2"
						@click="isTeacher = true">{{ $t('teacherConfirms.rateTeacher') }}</button>
					<button type="button" class="btn btn-theme mt-3 wid-100"
						v-if="orderInfo.status==2&&orderInfo.teacher_comment!=0&&orderInfo.exception_status!=2"
						@click="isTeacher = true"> {{ $t('teacherConfirms.viewEvaluation') }} </button>
				</div>

			</div>
		</div>
		<!-- 報告課程未完成 -->
		<div class="" v-if="isCourseCompleted">
			<courseNotCompleted :visible="isCourseCompleted" @cancel="isCourseCompleted = false"
				:order_id="Number(order_id)" @confirm="isCourseCompleted = false;getOrderDetail()"></courseNotCompleted>
		</div>
		<div class="" v-if="isTeacher">
			<teacher-evaluation :visible="isTeacher" @cancel="isTeacher = false" :order_id="Number(order_id)"
				@confirm="isTeacher = false;getOrderDetail()" :data="orderInfo"></teacher-evaluation>
		</div>
		<div v-if="openRemark">
			<upload-file-remark :visible="openRemark" :order_id="order_id" :status="appendix_status" @cancel="openRemark = false" @ok="openRemark = false;getOrderDetail()"></upload-file-remark>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import courseNotCompleted from "./components/courseNotCompleted.vue"
	import teacherEvaluation from "./components/teacherEvaluation.vue"
	import resolved from "./components/resolved.vue"
	import unresolved from "./components/unresolved.vue"
	import uploadFileVue from "../../components/upload/upload_file.vue"
	import uploadFileRemark from "../../components/upload/upload_file_remark.vue"

	export default {
		components: {
			courseNotCompleted,
			teacherEvaluation,
			resolved,
			unresolved,
			uploadFileVue,
			uploadFileRemark
		},
		data() {
			return {
				isCourseCompleted: false,
				isTeacher: false,
				isResolved: false,
				isUnresolved: false,
				order_id: 0,
				orderInfo: {},
				file: '',
				timeZone:localStorage.getItem('timeZone'),
				
				openRemark:false,
				appendix_status:1,//附录类型:1=笔记,2=作业,3=测验,学生不传1
			};
		},
		created() {
			this.order_id = this.$route.query.id;
			this.getOrderDetail();
		},
		methods: {
			formatNumber(num) {
			    // 将输入转换为字符串
			    let numStr = num.toString();
			    
			    // 如果数字长度超过6位，直接返回 L + 数字
			    if (numStr.length >= 6) {
			        return 'L' + numStr;
			    }
			
			    // 否则，补充0到6位
			    let paddedNum = numStr.padStart(6, '0');
			    return 'L' + paddedNum;
			},
			getFinDate(str){
				let date = new Date(str);
				
				// 增加三天
				date.setDate(date.getDate() + 3);
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
				let day = String(date.getDate()).padStart(2, '0');
				let hours = String(date.getHours()).padStart(2, '0');
				let minutes = String(date.getMinutes()).padStart(2, '0');
				let seconds = String(date.getSeconds()).padStart(2, '0');
				
				// 格式化输出
				let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				return formattedDate;
			},
			timeCompare24(str){
				// 给定的目标时间
				let targetTime = new Date(str);
				
				// 获取当前时间
				let currentTime = new Date();
				
				// 计算当前时间和目标时间的时间差（单位为毫秒）
				let timeDifference = targetTime - currentTime;
				
				// 判断目标时间是否在当前时间的24小时内（24小时 = 24 * 60 * 60 * 1000 毫秒）
				let isWithin24Hours = timeDifference >= 0 && timeDifference <= 24 * 60 * 60 * 1000;
				
				console.log(isWithin24Hours);
				// isWithin24Hours 将是 true 或 false，指示目标时间是否在当前时间的24小时内
				return isWithin24Hours
			},
			timeCompare(time) {
				const currentTime = new Date();
				const targetTime = new Date(time);

				if (currentTime < targetTime) {
					console.log('當前時間早於目標時間');
					return 2;
				} else if (currentTime > targetTime) {
					console.log('當前時間晚於目標時間');
					return 1;
				} else {
					console.log('當前時間等於目標時間');
					return false;
				}
			},
			showEnterClassRoom(startTime, endTime) {
				const currentTime = new Date();
				const start = new Date(startTime);
				const end = new Date(endTime);
				const startTenMinutesBefore = new Date(start.getTime() - 10 * 60 * 1000);
				const endFiveMinutesAfter = new Date(end.getTime() + 5 * 60 * 1000);

				return currentTime >= startTenMinutesBefore && currentTime <= endFiveMinutesAfter;
			},
			cancelOrder() {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmCancel'),
					content: this.$t('teacherConfirms.cancelClassText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/cancelOrder', {
							order_id: this.orderInfo.id
						}).then(res => {
							this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1,
								() => {
									this.getOrderDetail();
								});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			confirmationOrder() {
				this.$http.api('reservation/confirmationOrder', {
					order_id: this.order_id
				}).then(res => {
					this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1, () => {
						this.getOrderDetail();
					});
				});
			},
			enterClassroom() {
				this.$http.api('reservation/enterClassroom', {
					order_id: this.order_id
				}).then(res => {
					this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1, () => {
						this.getOrderDetail();
						 window.open(res.url, '_blank');
					});
				});
			},
			accomplishOrder() {
				this.$http.api('reservation/accomplishOrder', {
					order_id: this.order_id
				}).then(res => {
					this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1, () => {
						this.getOrderDetail();
					});
				});
			},
			handleUplodeTest(e) {
				this.file = e.file;
				this.uploadAppendix(3,e.name);
			},
			handleUplode(e) {
				this.file = e.file;
				this.uploadAppendix(2,e.name);
			},
			deleteAppendix(id) {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmDelete'),
					content: this.$t('teacherConfirms.deleteText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/deleteAppendix', {
							order_id: this.order_id,
							reservation_order_appendix_id: id
						}).then(res => {
							this.$message.success(this.$t(
								'teacherConfirms.operationSuccess'), 1, () => {
								this.getOrderDetail();
							});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			uploadAppendix(status,name) {
				this.$http.api('reservation/uploadAppendix', {
					order_id: this.order_id,
					status: status,
					file: this.file,
					name
				}).then(res => {
					this.file = '';
					this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1,
						() => {
							this.getOrderDetail();
						});
				});
			},
			consentException() {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmAgree'),
					content: this.$t('teacherConfirms.agreeResultText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/consentException', {
							order_id: this.order_id
						}).then(res => {
							this.$message.success(this.$t(
									'teacherConfirms.operationSuccess'), 1,
								() => {
									this.getOrderDetail();
								});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			platformRuling() {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmPlatformRuling'),
					content: this.$t('teacherConfirms.platformRulingText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/platformRuling', {
							order_id: this.order_id
						}).then(res => {
							this.$message.success(this.$t(
								'teacherConfirms.operationSuccess'
							), 1, () => {
								this.getOrderDetail();
							});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			getOrderDetail() {
				this.$http.api('reservation/orderDetail', {
					order_id: this.order_id
				}).then(res => {
					this.orderInfo = res.info;
				});
			}
		}
	};
</script>

<style>
	.tc-left-head {
		padding: 16px;
		background: linear-gradient(90deg, #02CAB9 0%, #0DD0C0 50%, #5AF9EE 100%);
	}

	.stc-wid-400 {
		width: 400px;
	}

	@media (max-width:575.98px) {
		.stc-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}

		.stc-wid-400 {
			width: 100% !important;
		}
	}

	@media (min-width: 576px) {
		.stc-container {
			margin: auto;
			width: 580px;
		}

	}

	@media (min-width: 768px) {
		.stc-container {
			margin: auto;
			width: 700px;
		}
	}

	@media (min-width: 992px) {
		.stc-container {
			margin: auto;
			width: 900px;
		}
	}

	@media (min-width: 1200px) {
		.stc-container {
			margin: auto;
			width: 1100px;
		}
	}

	@media (min-width: 1400px) {
		.stc-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>